export const LEVELUP_SIDEPANEL_ACTIONS = {
  OPEN_SIDEPANEL: 'OPEN_SIDEPANEL',
  CLOSE_SIDEPANEL: 'CLOSE_SIDEPANEL',
  SET_LEVEL_UP_TARGET_DATES: 'SET_LEVEL_UP_TARGET_DATES',
  SET_LEVEL_UP_PROGRESS_STATUSES: 'SET_LEVEL_UP_PROGRESS_STATUSES',
  SET_LEVEL_UP_COMPETENCY_DETAILS: 'SET_LEVEL_UP_COMPETENCY_DETAILS',
  UPDATE_COMPETENCY_TARGET_DATE: 'UPDATE_COMPETENCY_TARGET_DATE',
  UPDATE_COMPETENCY_PROGRESS_STATUS: 'UPDATE_COMPETENCY_PROGRESS_STATUS',
};
